import React from 'react';

const WardrobeIcon = ({ wardrobesDimensions, popupName }) => {
  const openPopup = () => {
    const popup = document.querySelector(`[data-popup-name="${popupName}"]`);
    if (!!popup) {
      popup.classList.add('open');
    }
  };

  return (
    <>
      {wardrobesDimensions ? (
        <button className="door__box" onClick={openPopup}>
          <p>Drzwi przesuwne</p>
          <div className="door2">
            <div className="door3"></div>
            <div className="door4"></div>
          </div>
        </button>
      ) : (
        <button className="door__box" onClick={openPopup}>
          <p>Drzwi uchylne</p>
          <div className="door">
            <div className="door1"></div>
          </div>
        </button>
      )}
    </>
  );
};

export default WardrobeIcon;
